import React from "react";
import { useSelector } from "react-redux";
import { Award, Star } from "lucide-react";

const PractitionerCard = ({ practitioner }) => {
  const fullName = `${practitioner.firstName} ${practitioner.lastName}`;
  const initials = `${practitioner.firstName?.[0] || ''}${practitioner.lastName?.[0] || ''}`;

  return (
    <div className="flex items-center gap-3">
      <div className="bg-[#EFF6FF] rounded-xl w-12 h-12 flex items-center justify-center flex-shrink-0">
        <span className="text-[#2563EB] font-poppins font-semibold text-base">
          {initials}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-poppins font-medium text-[14px] text-[#171717] mb-1 truncate">
          {fullName}
        </div>
        <div className="flex items-center justify-between gap-2">
          <span className="font-poppins text-[12px] text-[#64748B]">
            ID: {practitioner.practitionerId}
          </span>
          <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#EFF6FF]">
            <Star size={12} className="text-[#2563EB]" fill="currentColor" />
            <span className="font-poppins text-[12px] font-semibold text-[#2563EB]">
              {practitioner.sessionCount} sessions
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const Separator = () => (
  <div className="h-px w-full bg-[#F1F5F9]"></div>
);

export default function TopPractitionersSection() {
  // Data is fetched once by the Dashboard (useDashboardData)
  const { data: topPractitionersData, loading } = useSelector((state) => state.GET_TOP_PRACTITIONER);

  const practitioners = topPractitionersData?.payload || [];
  const topPractitioners = practitioners.slice(0, 3);

  return (
    <div className="bg-white rounded-2xl flex-1 p-[24px] border-[1px] border-solid border-[#E2E8F0] shadow-sm">
      <div className="flex items-center gap-2.5 -mx-[24px] -mt-[24px] px-[24px] py-[14px] bg-[#E7EDF5] rounded-t-[15px] mb-4">
        <div className="flex items-center justify-center w-[36px] h-[36px] rounded-xl bg-white text-[#EA580C] flex-shrink-0">
          <Award size={18} />
        </div>
        <h3 className="font-poppins font-semibold text-base text-[#171717] mb-0">
          Top Practitioners
        </h3>
      </div>

      <div className="space-y-3">
        {loading ? (
          <div className="text-center text-[#64748B] text-sm font-poppins">Loading...</div>
        ) : topPractitioners.length > 0 ? (
          topPractitioners.map((practitioner, index) => (
            <React.Fragment key={practitioner.practitionerId}>
              <PractitionerCard practitioner={practitioner} />
              {index < topPractitioners.length - 1 && <Separator />}
            </React.Fragment>
          ))
        ) : (
          <div className="text-center text-[#64748B] text-sm font-poppins">No practitioners found</div>
        )}
      </div>
    </div>
  );
}